import {Component, OnInit} from '@angular/core';
import {Pin, PinPopupComponent} from '@mydocma/bim-viewer';
import {CreationService} from '../mm-bim-view/creation-service/creation-service';
import {PinCreationState} from '../mm-bim-view/creation-service/pin-creation-state-enum';
import {ObjectSelectionService} from '../mm-bim-view/location-services/object-selection.service';

export enum PopupCloseResult {
  success,
  cancel,
}

@Component({
  selector: 'mydocma-creation-popup',
  templateUrl: './creation-popup.component.html',
  styleUrls: ['./creation-popup.component.scss']
})
export class CreationPopupComponent implements OnInit, PinPopupComponent {

  pin: Pin;
  public enumCreationState = PinCreationState;
  objectName;
  elemId;

  constructor(private objectSelectionService: ObjectSelectionService, public creationService: CreationService) {
  }

  ngOnInit(): void {

    if (this.creationService.creationState !== PinCreationState.Idle) {
      this.elemId = this.creationService.currentBimEditPin?.bimElementId;
    } else {
      this.elemId = this.objectSelectionService.selectedObject?.bimElementId;
    }
    const properties = this.creationService.bimViewerData.viewerService.forgeViewer.getProperties(+this.elemId, (res) => {
      this.objectName = res.name;
    });
  }

  clickPopup() {

  }

  // attachToPin(pin: Pin) {
  //   this.pin = pin;
  // }

  attachToPinData(data: any) {
  }

  moreInfoClick($event) {
    $event.stopPropagation();
    this.creationService.bimViewerData.viewerService.showPropertiesForObject(this.elemId);
  }

  hidePanel($event) {
    $event.stopPropagation();
    this.creationService.bimViewerData.viewerService.hidePropertiesForObject();
  }

  onDoneClick($event) {
    $event.stopPropagation();
    this.creationService.notifyCreationPopupClose(PopupCloseResult.success);
  }

  close($event) {
    $event.stopPropagation();
    if (this.creationService.creationState === PinCreationState.Idle) {
      this.objectSelectionService.closeSelectionPopup();
      return;
    }

    this.creationService.notifyCreationPopupClose(PopupCloseResult.cancel);
  }

  attachToPin(pinMarker): any {
  }
}
